<template>
<bulk-pricing-edit-modal :visible="visible"
	:title="title"
	:record="record"
	:record-title="recordTitle"
	:show-global-rate="!bulkSelection"
	v-on:closeModal="$emit('closeModal')"
	v-on:saveValue="saveCompiledValue">

	<div v-if="type == 'Material' && recordsAreCompiled" class="text-muted">Materials that exist in an assembly will not be edited</div>

</bulk-pricing-edit-modal>
</template>
<script type="text/javascript">
import BulkPricingEditModal from "@/components/BulkPricingEditModal"
import ProjectBidMixins from "@/mixins/ProjectBidMixins.js"
	
export default {
	name: "BidElementBulkEditModal",
	components: {
		BulkPricingEditModal
	},
	mixins: [ProjectBidMixins],
	props: [
		"visible",
		"title",
		"records",
		"type",
		"bidId",
		"component",
		"recordsAreCompiled"
	],
	data() {
		return {
			test: 1
		}
	},
	computed: {
		record() {
			if (this.records.length == 1)
				return this.records[0]

			return false
		},
		recordTitle() {
			if (this.record)
				return this.record.description
		},
		bulkSelection() {
			return this.records.length > 1
		}
	},
	methods: {
		saveCompiledValue(data) {
			let vm = this

			let field = data.field
			let value = data.value

			let type = this.type

			let matchingField = false //the comparison key to filter recordst to the correct ones
			if (type == 'EmployeeClassification')
				matchingField = "classification_id"
			else if (type == 'Equipment')
				matchingField = "equipment_type_id"

			let payload = {}

			let standaloneRecords = this.records
			if (type == 'Material') 
				standaloneRecords = this.records.filter(recordGroup => {
					if ("belongsToAssembly" in recordGroup && !recordGroup.belongsToAssembly)
						return true

					else if (!("belongsToAssembly" in recordGroup.parsedFields) || !recordGroup.parsedFields.belongsToAssembly)
						return true

					return false
				})

			if (this.recordsAreCompiled) {
				let records = []

					standaloneRecords.forEach(recordGroup => {
						records = [
							...records,
							...recordGroup.sourceRecords.map(record => {

								let objPayload = {
									id: record.objectRecordId
								}

								objPayload[field] = value

								return objPayload
							})
						]
					})

				payload.records = JSON.stringify(records)
			}
			else {
				payload.records = JSON.stringify(standaloneRecords.map(record => {
					let objPayload = {
						id: record.objectRecordId,
						bid_component_id: vm.component.id
					}

					objPayload[field] = value
					return objPayload
				}))
			}
			
			this.postData("JobBidComponentObject/save-batch",payload,true).then(response => {
				if (response.success) {
					vm.alertSaved(response.data.records_saved + " records changed")
					vm.fetchBidObjects(vm.bidId)
					vm.$emit('saved')
				}
			})
		}
	}
}
</script>